import React, { useContext, useEffect, useState } from 'react';

import ContainerSideBarComponent from '../../component/container/ContainerSidebarComponent';
import { EditAppointment, InputsAppointment, PropsListAppointment } from './ListAppointmentPageType';
import { CanvasPageStyled, ListAppointmentPageStyled } from './ListAppointmentPageStyled';
import { Button, Col, Container, Form, Modal, Offcanvas, Row } from 'react-bootstrap';
import { Controller, useForm } from 'react-hook-form';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { Horarios } from '../../../main/constant/HoursConstant';
import { FormatDate } from '../../../main/helper/dateFormatter';
import AlertComponent from '../../component/alert/AlertComponent';
import CalendarComponent from '../../component/calendario/CalendarioComponent';
import CalendarioFilterComponent from '../../component/calendario/CalendarioFilterComponent';

import { FaFilter } from 'react-icons/fa';
import { UseAlert } from '../../hook/AlertHook';
import { AuthContext } from '../../../data/context/AuthContext';
import MessageConstant from '../../../main/constant/MessageConstant';
import { StatusApontamento } from '../../../main/constant/StatusAgendamentoConstant';
import { ProfilesConstant } from '../../../main/constant/ProfilesConstant';

const ListAppointmentPage: React.FC<PropsListAppointment> = ({
  add,
  edit,
  getAppointment,
  appointment,
  listPatient,
  listProfessional,
}: PropsListAppointment) => {
  /**
   * Perfil de acesso
   */
  const PROFILE_DENTISTA = ProfilesConstant.dentist;

  /**
   * useForm
   */
  const {
    register,
    getValues,
    setValue,
    control,
    clearErrors,
    handleSubmit,
    formState: { errors },
  } = useForm<InputsAppointment>();

  /**
   * Alertas
   */
  const { showAlert } = UseAlert();

  /**
   * mostra modal
   */
  const [showOffcanvas, setShowOffcanvas] = useState(false);

  /**
   * handleCloseOffcanvas - fecha Offcanvas
   */
  const handleCloseOffcanvas = () => setShowOffcanvas(false);

  /**
   * handleShowOffcanvas - abre Offcanvas
   */
  const handleShowOffcanvas = () => {
    clearErrors(['patientId', 'professionalId', 'dateAppointment', 'start', 'end']);
    setValue('patientId', 0);
    setShowOffcanvas(true);
  };

  /**
   * mostra Modal
   */
  const [showModal, setShowModal] = useState(false);

  /**
   * handleCloseModal - fecha Modal
   */
  const handleCloseModal = async () => {
    setShowModal(false);
  };

  /**
   * handleShowModal - abre Modal
   */
  const handleShowModal = () => setShowModal(true);

  /**
   * handleAdd
   */
  const handleAdd = async () => {
    const model = {
      status: getValues('status') ?? '',
      patientId: getValues('patientId') ?? '',
      patientName: getValues('patientName') ?? '',
      professionalId: getValues('professionalId') ?? '',
      professionalName: getValues('professionalName') ?? '',
      dateAppointment: getValues('dateAppointment') ?? '',
      start: getValues('start') ?? '',
      end: getValues('end') ?? '',
      chair: getValues('chair') ?? 0,
      observation: getValues('observation') ?? '',
    };

    await add(model);
    handleCloseOffcanvas();
  };

  /**
   * handleEdit
   */
  const handleEdit = async () => {
    const model: EditAppointment = {
      id: getValues('id') ?? '',
      status: getValues('status') ?? '',
      patientId: getValues('patientId') ?? '',
      patientName: getValues('patientName') ?? '',
      professionalId: getValues('professionalId') ?? '',
      professionalName: getValues('professionalName') ?? '',
      dateAppointment: getValues('dateAppointment') ?? '',
      start: getValues('start') ?? '',

      end: getValues('end') ?? '',
      chair: getValues('chair') ?? '',
      observation: getValues('observation') ?? '',
    };

    await edit(model);
    handleCloseOffcanvas();
  };

  const handleSubmitValidation = async () => {
    title === 'Novo Agendamento' ? await handleAdd() : await handleEdit();
  };

  /**
   * setModel
   * @param model
   */
  const setModel = (model: any) => {
    resetModel();
    if (model !== null) {
      setValue('id', model.id);
      setValue('status', model.status);
      setValue('patientId', model.patientId);
      setValue('patientName', model.patientName);
      setValue('professionalId', model.professionalId);
      setValue('professionalName', model.professionalName);
      setValue('dateAppointment', FormatDate.splitDateTime(model.start).date);
      setValue('start', FormatDate.splitDateTime(model.start).time);
      setValue('end', FormatDate.splitDateTime(model.end).time);
      setValue('chair', model.chair);
      setValue('observation', model.observation);
      setValue('scheduledBy', model.scheduledBy);
      setValue('scheduledAt', model.scheduledAt);
      setValue('clinicId', model.clinicId);
    }
  };

  /**
   * resetModel
   */
  const resetModel = () => {
    setValue('id', 0);
    setValue('status', '');
    setValue('patientId', 0);
    setValue('patientName', '');
    if (listProfessional.length > 1) {
      setValue('professionalId', 0);
      setValue('professionalName', '');
    }
    setValue('start', '');
    setValue('end', '');
    setValue('chair', 0);
    setValue('observation', '');
    setValue('scheduledBy', 0);
    setValue('scheduledAt', '');
    setValue('clinicId', 0);
  };

  /**
   * apontamento clicado em branco no calendario
   */
  const handleSelect = (params: any) => {
    setModel(null);
    setValue('dateAppointment', FormatDate.formatToDateOnly(params.date));
    setValue('start', FormatDate.formatDateWith15MinEnd(params.dateStr).start);
    setValue('end', FormatDate.formatDateWith15MinEnd(params.dateStr).end);
    if (listProfessional.length === 1) {
      setValue('professionalName', listProfessional[0].name);
      setValue('professionalId', listProfessional[0].id);
    }
    setTitle('Novo Agendamento');
    handleShowOffcanvas();
  };

  /**
   * apontamento selecionado no calendario
   * @param e
   */
  const handleSelectAppointment = async (e: any) => {
    if (disableSave(e.event.extendedProps.professionalName)) {
      showAlert({
        show: true,
        content: `Somente o dentista ${e.event.extendedProps.professionalName} pode editar este apontamento`,
        color: 'warning',
        time: 2000,
      });
    } else {
      setTitle(`Agendamento ${e.event.title}`);
      await getAppointment(e.event.id);
      setModel(appointment);
      handleShowOffcanvas();
    }
  };

  /**
   * Titulo da pagina
   */
  const [title, setTitle] = useState('');

  useEffect(() => {
    setModel(appointment);
  }, [appointment]);

  /**
   * usuario logado
   */
  const { loggedUserData } = useContext(AuthContext);
  const userRoles = loggedUserData?.roles || [];
  const ROLE_PROFESSIONAL = PROFILE_DENTISTA;
  const roleIsProfessional = userRoles.includes(ROLE_PROFESSIONAL);
  const disableSave = (professionalName: string): boolean => {
    const userName = loggedUserData?.name;
    if ((userName !== undefined || userName !== null) && professionalName !== undefined) {
      if (roleIsProfessional && userName!.toLowerCase() === professionalName.toLowerCase()) {
        return false;
      }
    }
    return roleIsProfessional;
  };

  const loadFromLocalStorage = (key: string): any[] => {
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : []; // Retorna um array vazio se não houver dados
  };

  const mostrarCalendario0 = (): boolean => {
    const savedProfessionals0 = loadFromLocalStorage(`calendario_selected_professionals_0`);
    const savedStatuses0 = loadFromLocalStorage(`calendario_selected_statuses_0`);
    return savedProfessionals0.length > 0 || savedStatuses0.length > 0;
  };

  const mostrarCalendario1 = (): boolean => {
    const savedProfessionals1 = loadFromLocalStorage(`calendario_selected_professionals_1`);
    const savedStatuses1 = loadFromLocalStorage(`calendario_selected_statuses_1`);

    return savedProfessionals1.length > 0 || savedStatuses1.length > 0;
  };

  const mostrarCalendario2 = (): boolean => {
    const savedProfessionals2 = loadFromLocalStorage(`calendario_selected_professionals_2`);
    const savedStatuses2 = loadFromLocalStorage(`calendario_selected_statuses_2`);

    return savedProfessionals2.length > 0 || savedStatuses2.length > 0;
  };

  const getVisibleCalendars = () => {
    const calendars = [];
    if (mostrarCalendario0()) calendars.push(0);
    if (mostrarCalendario1()) calendars.push(1);
    if (mostrarCalendario2()) calendars.push(2);
    return calendars;
  };

  // No JSX, usar a lógica baseada na quantidade de calendários visíveis
  const visibleCalendars = getVisibleCalendars();

  return (
    <ContainerSideBarComponent>
      <AlertComponent />
      <ListAppointmentPageStyled>
        <Container fluid className="title-page">
          <h3>Agendamento</h3>
        </Container>
        <Container fluid>
          <Row className="row-field-filter">
            <Col sm={12} className="filter-btn">
              <Button size="sm" variant="outline-primary" style={{ float: 'right', marginRight: '5px' }} onClick={handleShowModal}>
                <FaFilter />
                <span>Filtro</span>
              </Button>
            </Col>
          </Row>
        </Container>
        {visibleCalendars.length === 0 && (
          <div className="calendario">
            <CalendarComponent
              numeroCalendario={0}
              rangeTimeDay={{
                start: '07:00:00',
                end: '21:00:00',
              }}
              onClickDate={handleSelect}
              onClickEvent={handleSelectAppointment}
              listProfessional={listProfessional}
            />
          </div>
        )}

        {visibleCalendars.length === 1 && (
          <div className="calendario">
            <CalendarComponent
              numeroCalendario={visibleCalendars[0]}
              rangeTimeDay={{
                start: '07:00:00',
                end: '21:00:00',
              }}
              onClickDate={handleSelect}
              onClickEvent={handleSelectAppointment}
              listProfessional={listProfessional}
            />
          </div>
        )}

        {visibleCalendars.length > 1 && (
          <div className="calendario-container">
            <div className="calendario-grid">
              {visibleCalendars.map((calendarNumber) => (
                <CalendarComponent
                  key={calendarNumber}
                  numeroCalendario={calendarNumber}
                  rangeTimeDay={{
                    start: '07:00:00',
                    end: '21:00:00',
                  }}
                  onClickDate={handleSelect}
                  onClickEvent={handleSelectAppointment}
                  listProfessional={listProfessional}
                />
              ))}
            </div>
          </div>
        )}

        <Offcanvas show={showOffcanvas} onHide={handleCloseOffcanvas} placement="end">
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>{title}</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <CanvasPageStyled>
              <Container fluid>
                <Form onSubmit={handleSubmit(handleSubmitValidation)}>
                  <input type="hidden" id="id" {...register('id')} />
                  <input type="hidden" id="patientId" {...register('patientId')} />
                  <input type="hidden" id="professionalId" {...register('professionalId')} />
                  <input type="hidden" id="scheduledBy" {...register('scheduledBy')} />
                  <input type="hidden" id="scheduledAt" {...register('scheduledAt')} />

                  <input type="hidden" id="clinicId" />

                  <div className="container-field-canvas">
                    <Row className="row-field-canvas">
                      <Col>
                        <Button size="sm" style={{ float: 'right' }} type="submit">
                          Salvar
                        </Button>
                      </Col>
                    </Row>

                    <Row className="row-field-canvas">
                      <Col>
                        <Form.Label>Nome do Paciente</Form.Label>
                        <Form.Select
                          aria-label="patientId"
                          {...register('patientId', {
                            required: 'campo obrigatório',
                            validate: (value) => value !== 0 || 'campo obrigatório',
                            valueAsNumber: true,
                          })}>
                          <option value={0}>Selecione o Nome do Paciente</option>
                          {listPatient.map((item: any) => (
                            <option key={item.id} value={item.id}>
                              {item.name}
                            </option>
                          ))}
                        </Form.Select>
                        {errors.patientId && <span className="text-danger">{errors.patientId.message}</span>}
                      </Col>
                    </Row>
                    <Row className="row-field-canvas">
                      <Col>
                        <Form.Label>Nome do Profissional</Form.Label>
                        <Form.Select
                          aria-label="professionalId"
                          {...register('professionalId', {
                            required: 'campo obrigatório',
                            validate: (value) => value !== 0 || 'campo obrigatório',
                            valueAsNumber: true,
                          })}
                          disabled={listProfessional.length === 1}>
                          <option value={0}>Selecione o Nome do Profissional</option>
                          {listProfessional.map((item: any) => (
                            <option key={item.id} value={item.id}>
                              {item.name}
                            </option>
                          ))}
                        </Form.Select>
                        {errors.professionalId && <span className="text-danger">{errors.professionalId.message}</span>}
                      </Col>
                    </Row>
                    <Row className="row-field-canvas">
                      <Col xs={6}>
                        <Form.Label>Data Inicio</Form.Label>
                        <Form.Control type="date" min="1900-01-01" max="2100-12-31" {...register('dateAppointment', { required: 'campo obrigatório' })} />
                        {errors.dateAppointment && <span className="text-danger">{errors.dateAppointment.message}</span>}
                      </Col>
                    </Row>
                    <Row className="row-field-canvas">
                      <Col>
                        <Form.Label>Hora inicio</Form.Label>
                        <Form.Select
                          aria-label="start"
                          {...register('start', {
                            required: 'campo obrigatório',
                            validate: (value) => value !== '' || 'campo obrigatório',
                          })}>
                          <option value="">Selecione</option>
                          {Horarios.map((item: any) => (
                            <option key={item} value={item}>
                              {item}
                            </option>
                          ))}
                        </Form.Select>
                        {errors.start && <span className="text-danger">{errors.start.message}</span>}
                      </Col>
                      <Col>
                        <Form.Label>Hora fim</Form.Label>
                        <Form.Select
                          aria-label="end"
                          {...register('end', {
                            required: 'campo obrigatório',
                            validate: (value) => value !== '' || 'campo obrigatório',
                          })}>
                          <option value="">Selecione</option>
                          {Horarios.map((item: any) => (
                            <option key={item} value={item}>
                              {item}
                            </option>
                          ))}
                        </Form.Select>
                        {errors.end && <span className="text-danger">{errors.end.message}</span>}
                      </Col>
                    </Row>
                    <Row className="row-field-canvas">
                      <Col>
                        <Form.Group>
                          <Form.Label>Status</Form.Label>
                          <Controller
                            name="status"
                            control={control}
                            defaultValue="N"
                            render={({ field }) => (
                              <Form.Select {...field}>
                                <option value="N">Não Confirmado</option>
                                <option value="A">Atendido</option>
                                <option value="S">Confirmado</option>
                                <option value="I">Falta</option>
                                <option value="O">Encaixe</option>
                              </Form.Select>
                            )}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="row-field-canvas">
                      <Col>
                        <Form.Label>Observação</Form.Label>
                        <Form.Control placeholder="Observação" as="textarea" rows={10} {...register('observation')} />
                      </Col>
                    </Row>
                  </div>
                </Form>
              </Container>
            </CanvasPageStyled>
          </Offcanvas.Body>
        </Offcanvas>

        <Modal show={showModal} onHide={handleCloseModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Filtrar Profissionais</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col>
                <CalendarioFilterComponent numeroCalendario={0} professionals={listProfessional} statuses={StatusApontamento} />
              </Col>
              <Col>
                <CalendarioFilterComponent numeroCalendario={1} professionals={listProfessional} statuses={StatusApontamento} />
              </Col>
              <Col>
                <CalendarioFilterComponent numeroCalendario={2} professionals={listProfessional} statuses={StatusApontamento} />
              </Col>
            </Row>
          </Modal.Body>
        </Modal>
      </ListAppointmentPageStyled>
    </ContainerSideBarComponent>
  );
};

export default ListAppointmentPage;
